import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@welldev-group/rcl-radio';

const VerificationRadioGroup = ({ status, isEditing, onStatusChange }) => {
  const VERIFICATION_STATUS = {
    unverified: 'unverified',
    verified: 'verified',
  };

  if (!isEditing) return null;

  return (
    <div className="affiliate-config-verification__radio-group">
      <Radio
        name="verified"
        label={I18n.t(
          'components.affiliate_three_sixty.affiliate.configuration.affiliate_verification.status.verified',
        )}
        size="medium"
        isChecked={status === VERIFICATION_STATUS.verified}
        onChange={() => onStatusChange(VERIFICATION_STATUS.verified)}
      />
      <Radio
        name="unverified"
        label={I18n.t(
          'components.affiliate_three_sixty.affiliate.configuration.affiliate_verification.status.unverified',
        )}
        size="medium"
        isChecked={status === VERIFICATION_STATUS.unverified}
        onChange={() => onStatusChange(VERIFICATION_STATUS.unverified)}
      />
    </div>
  );
};

VerificationRadioGroup.propTypes = {
  status: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onStatusChange: PropTypes.func.isRequired,
};

export default VerificationRadioGroup;
